module.exports = __webpack_public_path__ + "8c0a912043f8c58cca978e4bf2ac71f6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-20.png
// module id = 2666
// module chunks = 0